import * as mutationTypes from 'store/mutationTypes'
import * as actions from './actions'

export default {
  state: {
    visible: false,
  },
  actions,
  mutations: {
    [mutationTypes.SHOW_CHAT_APP](state) {
      state.visible = true
    },
    [mutationTypes.HIDE_CHAT_APP](state) {
      state.visible = false
    },
    [mutationTypes.TOGGLE_CHAT_APP]() {
      //NOTE: this a no-op, it's just used by the ChatApp component to trigger toggling the whole chat app
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/chatApp/index.js